"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useDashboardState } from "@/lib/dashboard-state";

/**
 * Component to dynamically update favicon and page title based on organization branding
 */
export function WhiteLabelMeta() {
  const $ = _c(8);
  const {
    selectedOrganization
  } = useDashboardState();
  const pathname = usePathname();
  let t0;
  if ($[0] !== selectedOrganization) {
    t0 = () => {
      if (!selectedOrganization) {
        return;
      }
      const brandTitle = selectedOrganization.brandName || selectedOrganization.name || "Wirtual";
      const brandFavicon = selectedOrganization.brandFaviconUrl;
      console.log("WhiteLabelMeta - Setting title to:", brandTitle);
      const updateFavicon = () => {
        if (!brandFavicon) {
          return;
        }
        console.log("Updating favicon to:", brandFavicon);
        const existingLinks = document.querySelectorAll("link[rel*='icon']");
        existingLinks.forEach(_temp);
        const formats = [{
          rel: "icon",
          type: "image/x-icon"
        }, {
          rel: "shortcut icon",
          type: "image/x-icon"
        }, {
          rel: "apple-touch-icon",
          type: "image/png"
        }];
        formats.forEach(format => {
          const faviconLink = document.createElement("link");
          faviconLink.rel = format.rel;
          faviconLink.type = format.type;
          faviconLink.href = brandFavicon + "?v=" + Date.now() + Math.random();
          faviconLink.setAttribute("data-white-label", "true");
          document.head.appendChild(faviconLink);
        });
        console.log("Favicon updated successfully");
      };
      document.title = brandTitle;
      updateFavicon();
      const observer = new MutationObserver(mutations => {
        if (document.title !== brandTitle) {
          console.log("Title was changed to:", document.title, "- reverting to:", brandTitle);
          document.title = brandTitle;
        }
        mutations.forEach(mutation => {
          if (mutation.type === "childList" && brandFavicon) {
            const currentFavicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
            if (!currentFavicon || !currentFavicon.href.includes(brandFavicon) && !currentFavicon.getAttribute("data-white-label")) {
              console.log("Favicon was changed - restoring custom favicon");
              updateFavicon();
            }
          }
        });
      });
      observer.observe(document.querySelector("head"), {
        childList: true,
        subtree: true
      });
      return () => observer.disconnect();
    };
    $[0] = selectedOrganization;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = selectedOrganization?.id;
  const t2 = selectedOrganization?.brandName;
  const t3 = selectedOrganization?.brandFaviconUrl;
  const t4 = selectedOrganization?.name;
  let t5;
  if ($[2] !== pathname || $[3] !== t1 || $[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = [t1, t2, t3, t4, pathname];
    $[2] = pathname;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t0, t5);
  return null;
}
function _temp(link) {
  return link.remove();
}